import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from "vue";
import FilterMint from "../filters/FilterMint.vue";
import {EFilterOperatorsParity, FilterOperatorsBitmap, ISignalFilters} from "@/shared";
import FiltersGeneric from "@/components/automation/filters/FiltersGeneric.vue";

// props
interface IProps {
	data?: any;
	filters?: ISignalFilters;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SignalTokenTrade',
  props: {
    data: null,
    filters: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	data?: any;
	filters?: ISignalFilters;
};




//TODO should merge with previously provided filters so we have correct data
const _availableFilters = [
	{key: "inputMint", name: "Input Mint", operator: 0, type: "mint", value: null, ops: new FilterOperatorsBitmap(EFilterOperatorsParity)},
	{key: "outputMint", name: "Output Mint", operator: 0, type: "mint", value: null, ops: new FilterOperatorsBitmap(EFilterOperatorsParity)},
	{key: "wallet", name: "Wallet", operator: 0, type: "wallet", value: null, ops: new FilterOperatorsBitmap(EFilterOperatorsParity)},
	{key: "inAmount", name: "In Amount", operator: 0, type: "uint64", value: null},
	{key: "outAmount", name: "Out Amount", operator: 0, type: "uint64", value: null},
	{key: "value", name: "Trade Value", operator: 0, type: "uint64", value: null}
]


const isInvalid = computed<boolean>(
	() => {
		for (let i = 0; i < FilterGenericRef.value?.data.length; i++) {
			if (!FilterGenericRef.value?.data[i]?.value || FilterGenericRef.value?.data[i]?.value === 0) return true
		}
		return false

	});

const getData = computed<any>(() => {
	return {
		mint: mint.value,
		filters: FilterGenericRef.value?.data,
	};
});

// methods

// data
const FilterGenericRef = ref<InstanceType<typeof FiltersGeneric> | null>(null);

const mint = ref<string>(props.data?.mint ?? "");

// expose
expose({isInvalid, data: getData});

return { __sfc: true,props, _availableFilters, isInvalid, getData, FilterGenericRef, mint, FilterMint, FiltersGeneric }
}

})